export const isNotNullUndefinedOrEmpty = (value) => {
	return (value !== undefined && value !== null && value !== '');
}

export const isNullUndefinedOrEmpty = (value) => {
	return !isNotNullUndefinedOrEmpty(value);
}